import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPolicy } from '@/features/privacy-policy';

export const Route = createFileRoute('/_authenticated/privacy-policy/')({
    head: () => ({ meta: [{ title: 'Privacy Policy | promote.fun' }] }),
    component: PrivacyPolicy,
});
